import axios from 'axios'

export function getGlobalConfig () {
  return new Promise((resolve, reject) => {
    axios.post(process.env.VUE_APP_BASE_API_BUSINESS + '/cloud/oem/config/ui', {}, {
      headers: {
        // domainUrl: window.location.href.split('://')[0] + '://' + window.location.href.split('://')[1].split('/')[0]
        domainUrl: process.env.VUE_APP_DOMAIN_URL
      }
    }).then(res => {
      if (res.data.code === 1) {
        resolve(res.data.data)
        return
      }
      reject(res)
    }).catch(err => {
      reject(err)
    })
  })
}
